import IntegrationTaskResourceModel from '../../generated/types/model/resource/IntegrationTaskResourceModel';

export default class IntegrationTaskResourceViewModel extends IntegrationTaskResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
